import ButtonDefault from 'ui/src/buttons/ButtonDefault'
import ModalDefault from '@/components/parts/modal/ModalDefault'
import TableModalConfirmDelete from '@/components/partsGroups/tables/TableModalConfirmDelete'
import { useLocale } from '@/features/i18n/hooks/useLocale'

interface Props {
  className?: string
  isOpen?: boolean
  data?: any
  onClose?: () => void
  deleteAction: () => void
}

export default function ModalConfirmDelete({
  className,
  isOpen = false,
  data,
  onClose,
  deleteAction,
}: Props) {
  const { t } = useLocale()
  return (
    <ModalDefault
      className="text-center"
      title={t.profile.ConfirmDeleteMessage}
      isOpen={isOpen}
      onClose={onClose}
    >
      <TableModalConfirmDelete
        isOpen={isOpen}
        data={data}
        onClose={onClose}
        deleteAction={deleteAction}
      />
    </ModalDefault>
  )
}
